var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoLoupe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #003189;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1-2",
    "data-name": "Warstwa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6521",
    "data-name": "Group 6521"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8563",
    "data-name": "Path 8563",
    className: "cls-1",
    d: "m31.5,0C14.1,0,0,14.1,0,31.5s14.1,31.5,31.5,31.5,31.5-14.1,31.5-31.5S48.9,0,31.5,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7011",
    "data-name": "Path 7011",
    className: "cls-2",
    d: "m45.8,43.33c-3.14-3.14-6.28-6.28-9.42-9.42-.06-.06-.13-.11-.2-.15,3.07-4.02,2.3-9.77-1.72-12.84-4.02-3.07-9.77-2.3-12.84,1.72-2.48,3.24-2.51,7.74-.08,11.01,1.33,1.83,3.3,3.09,5.52,3.52,2.6.54,5.3-.08,7.4-1.7.04.07.08.14.13.21,3.12,3.12,6.23,6.24,9.35,9.36.07.07.14.15.22.21.35.32.86.4,1.28.18.46-.19.77-.64.78-1.15,0-.37-.16-.72-.44-.96m-16.91-8.21c-3.82,0-6.91-3.1-6.91-6.92s3.1-6.91,6.92-6.91c3.82,0,6.91,3.1,6.91,6.92.02,3.79-3.03,6.88-6.82,6.91-.03,0-.06,0-.1,0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLoupe);
export default __webpack_public_path__ + "static/media/ico-loupe.7f16bf7ad3b92424ac30951634570ef8.svg";
export { ForwardRef as ReactComponent };